var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.614 12.113h12.108V9.018h2.556v3.095h12.108L31 9.826l-1.614-1.884h-5.112c.807-.717 1.937-2.663 0-4.708-2.422-2.556-4.844-.538-5.92.672-.86.969-1.076 2.556-1.076 3.23L16 7.773l-1.278-.64c0-.672-.215-2.26-1.076-3.228-1.076-1.21-3.498-3.228-5.92-.672-1.937 2.045-.807 3.99 0 4.708H2.614L1 9.826l1.614 2.287zM3.422 25.7V14.803h11.3v14.395H7.726c-2.26 0-3.811-2.332-4.304-3.498zM13.646 7.808c-1.346-.09-4.117-.458-4.44-1.211-.403-.942.673-5.516 4.44 1.21zM28.579 25.7V14.803H17.277v14.395h6.996c2.26 0 3.811-2.332 4.305-3.498zM18.353 7.808c1.346-.09 4.117-.458 4.44-1.211.403-.942-.673-5.516-4.44 1.21z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGto);
export default __webpack_public_path__ + "static/media/GTO.12c6ec4b31f5a1487d4ec5859899479a.svg";
export { ForwardRef as ReactComponent };